const API_STACK = 'auth/';

export const GET_PROFILE = API_STACK + 'profile';
export const POST_PROVIDER = API_STACK + 'providersignup';